/**
 * Login Page
 * Requirements: 6.2
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DesignLoginForm } from '../components/DesignLoginForm';
import { NewPasswordRequiredForm } from '../components/NewPasswordRequiredForm';

export const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading, requiresNewPassword } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // ログイン済みの場合はダッシュボードにリダイレクト
    if (!isLoading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // 認証状態確認中はローディング表示（または何も表示しない）
  if (isLoading) {
    return null;
  }

  // 未ログインの場合のみログインフォームを表示
  if (isAuthenticated) {
    return null; // リダイレクト中
  }

  // 初回パスワード変更が必要な場合
  if (requiresNewPassword) {
    return <NewPasswordRequiredForm />;
  }

  return <DesignLoginForm />;
};
